/*
 * Reusable message bar for success, error, warning, info.
 */

import React from "react";

export default function MessageBar({ message, getMessageBarClass }) {
  if (!message) return null;
  return (
    <div className={`p-3 rounded-md ${getMessageBarClass(message.type)}`}>
      {message.text}
    </div>
  );
}
